import { chatConditionalTransport } from "./ChatConditionalTransport";
import { RuntimeChatClient } from "./api";
import { IApiConfig } from "./ApiConfig";

/** Multipart transport extension; the remaining contract is generated from api-runtime. */
export class RuntimeChatUploadClient extends RuntimeChatClient {
  constructor(
    config: IApiConfig,
    private readonly endpoint: string,
    private readonly transport: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> } = window
  ) {
    super(config, endpoint, chatConditionalTransport(transport));
  }

  async uploadFile(definitionId: string, componentId: string, conversationId: string, sessionKey: string | undefined, file: File, signal?: AbortSignal) {
    const body = new FormData();
    body.append("file", file, file.name);
    const path = [definitionId, componentId, "Sessions", conversationId, "Attachments"].map(encodeURIComponent).join("/");
    const query = sessionKey === undefined ? "" : `?sessionKey=${encodeURIComponent(sessionKey)}`;
    const options = await this.transformOptions({ method: "POST", body, signal });
    return this.processUpload(await this.transport.fetch(`${this.endpoint}/Chat/${path}${query}`, options));
  }
}
